import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    // Вкладки
    tabContent: 'Инструкция',
    tabCover: 'Обложка',
    tabAccess: 'Доступ',
    author: 'Автор',
    // Проверка
    lockNoticeUnpublished:
      'Статья на проверке — редактирование вернётся после решения. Отозвать заявку можно во вкладке «Доступ».',
    lockNotice: 'Статья на проверке — редактирование вернётся после решения.',
    // Обновить / отменить правки
    updateSentForReview: 'Изменения отправлены на проверку',
    updateApplied: 'Изменения применены',
    discardChanges: 'Вернуть опубликованную версию',
    saveChangesFirst: 'Дождитесь сохранения изменений',
    retryIn: (time: string) => `Повторить через ${time}`,
    update: 'Обновить',
    liveChanges:
      'Вы изменили опубликованную статью. Чтобы изменения увидели читатели, нажмите «Обновить».',
    discardSubject: 'статьи',
    discardDirtyNote:
      'Несохранённые изменения останутся в форме — их сохранение заведёт новый черновик',
    // Доступ
    accessSentForReview: 'Статья отправлена на проверку',
    accessPrivate: 'Статья закрыта',
    accessLink: 'Доступ по ссылке',
    accessPublic: 'Статья в каталоге',
    // Тулбар
    save: 'Сохранить',
    saved: 'Сохранено',
    // Перевод
    translatePending: 'Перевожу…',
    translateRunning: 'Перевожу…',
    translateRetrying: 'Повторная попытка…',
    translateFrozen: 'Статья на проверке — перевод недоступен',
    translateSaveFirst: 'Для перевода необходимо сначала сохранить инструкцию',
    translationFresh: 'Перевод актуален',
    translationInDraft: 'Перевод в черновике — нажмите «Обновить», чтобы он появился у читателей',
    translationChanged: 'Текст менялся после перевода — нажмите, чтобы перевести заново',
    translationStale: 'Перевод устарел',
    translateStaleAria: 'Перевод устарел — перевести заново',
    translate: 'Перевести',
    translateAgain: 'Перевести заново',
    translateRateLimit: (minutes: number) =>
      `Превышен лимит переводов. Попробуйте через ${minutes} мин.`,
    translateStartFailed: 'Не удалось запустить перевод',
    translateTimeout: 'Превышено время ожидания перевода',
    translateDone: 'Перевод готов',
    translateDoneDraft:
      'Перевод сохранён в черновик. Нажмите «Обновить», чтобы он появился у читателей',
    translateStatusFailed: 'Не удалось получить статус перевода',
    // Сохранение / удаление
    fillTitle: 'Заполните заголовок',
    fillContent: 'Заполните контент',
    noChanges: 'Нет изменений',
    deleteConfirm: 'Удалить статью? Действие нельзя отменить.',
    deleted: 'Удалено',
    // Загрузка
    loadFailedTitle: 'Ой, статья не открылась…',
    loadFailedHint: 'Проверьте интернет и попробуйте ещё раз.',
    retry: 'Повторить',
    back: 'Назад',
    cannotEdit: 'Вы не можете редактировать эту статью',
    cannotEditHint:
      'Возможно, она в черновике и недоступна по публичной ссылке, или у вас нет прав редактирования.',
  },
  en: {
    tabContent: 'Article',
    tabCover: 'Cover',
    tabAccess: 'Access',
    author: 'Author',
    lockNoticeUnpublished:
      'The article is under review — you can edit it again once the review is done. To withdraw it from review, go to the “Access” tab.',
    lockNotice: 'The article is under review — you can edit it again once the review is done.',
    updateSentForReview: 'Changes sent for review',
    updateApplied: 'Changes published',
    discardChanges: 'Revert to published version',
    saveChangesFirst: 'Wait for your changes to save',
    retryIn: (time: string) => `Retry in ${time}`,
    update: 'Update',
    liveChanges: 'You changed the published article. To show the changes to readers, click Update.',
    discardSubject: 'the article',
    discardDirtyNote: 'Unsaved changes will stay in the form — saving them will start a new draft',
    accessSentForReview: 'Article sent for review',
    accessPrivate: 'Article is private',
    accessLink: 'Article is available by link',
    accessPublic: 'Article is in the catalog',
    save: 'Save',
    saved: 'Saved',
    translatePending: 'Translating…',
    translateRunning: 'Translating…',
    translateRetrying: 'Retrying…',
    translateFrozen: 'The article is under review — translation is unavailable',
    translateSaveFirst: 'Save the article first to translate it',
    translationFresh: 'Translation is up to date',
    translationInDraft: 'The translation is in the draft — click “Update” to show it to readers',
    translationChanged: 'The text changed after translation — click to translate again',
    translationStale: 'Outdated',
    translateStaleAria: 'Translation is out of date — translate again',
    translate: 'Translate',
    translateAgain: 'Translate again',
    translateRateLimit: (minutes: number) =>
      `Translation limit reached. Try again in ${minutes} min.`,
    translateStartFailed: 'Couldn’t start translation',
    translateTimeout: 'Translation timed out',
    translateDone: 'Translation ready',
    translateDoneDraft: 'Translation saved to the draft. Click “Update” to show it to readers',
    translateStatusFailed: 'Couldn’t get translation status',
    fillTitle: 'Enter a title',
    fillContent: 'Add the article text',
    noChanges: 'No changes',
    deleteConfirm: 'Delete the article? This can’t be undone.',
    deleted: 'Article deleted',
    loadFailedTitle: 'Oops, the article didn’t load…',
    loadFailedHint: 'Check your internet and try again.',
    retry: 'Retry',
    back: 'Back',
    cannotEdit: 'You can’t edit this article',
    cannotEditHint:
      'It may be a draft that isn’t available via the public link, or you don’t have edit permissions.',
  },
})
